<script setup>
import { UploadIcon, BellIcon, SearchIcon } from 'vue-tabler-icons';
import UserCard from '@/components/UserCard.vue';

const routes = [
  { name: 'Home', url: '/' },
  { name: 'Configurable Items', url: '/configurable-items' },
  { name: 'Models', url: '/models' },
  { name: 'Materials', url: '/materials' },
  { name: 'Textures', url: '/textures' },
];

const build = process.env.VUE_APP_BUILD;
</script>

<template>
  <header class="app-header flex h-16 items-center bg-white">
    <!-- Nav -->
    <nav class="flex flex-grow items-center gap-12 px-4">
      <router-link v-for="{ name, url } in routes" v-slot="{ href, navigate, isActive }" :key="url" :to="url" custom>
        <a
          :href="href"
          class="nav-item hover:text-brand-400"
          :class="{ 'text-brand-500': isActive, 'text-gray-500': !isActive }"
          @click="navigate"
          >{{ name }}</a
        >
      </router-link>

      <div class="build-number flex flex-grow items-baseline justify-center text-xs font-semibold text-gray-400">
        <small>Build Number:</small> &nbsp; {{ build }}
      </div>

      <router-link v-slot="{ href, navigate, isActive }" to="/models/create" custom>
        <a
          :href="href"
          class="app-header__upload-icon"
          :class="{
            'border border-brand-500 bg-brand-500 font-bold text-white': isActive,
            'border border-brand-500 text-brand-500': !isActive,
          }"
          @click="navigate"
        >
          <upload-icon class="h-4 w-4" /> Upload
        </a>
      </router-link>
    </nav>

    <!-- Search -->
    <div class="relative mx-4 flex flex-wrap items-stretch">
      <span class="absolute z-10 h-full w-8 rounded py-3 pl-3 text-center text-lg font-normal leading-snug">
        <search-icon class="h-full py-1"></search-icon>
      </span>
      <input
        type="text"
        placeholder="Search"
        class="outline-none relative w-full rounded-lg border-none bg-offwhite px-3 py-3 pl-10 text-base"
      />
      <div class="absolute top-10 hidden rounded-xl bg-white p-2 shadow">
        Routes
        <ul class="">
          <li class="ml-2 text-xs">Environments</li>
        </ul>
        <hr />

        Configurable Items
        <ul class="">
          <li class="ml-2 text-xs">See More</li>
        </ul>
        <hr />

        Materials
        <ul class=""></ul>
        <hr />
      </div>
    </div>

    <div class="notification-icon outline-none cursor-pointer rounded-full p-1 text-2xl hover:bg-gray-100">
      <bell-icon class="h-6 w-6" />
    </div>

    <user-card></user-card>
  </header>
</template>

<style lang="postcss" scoped>
a.nav-item {
  @apply text-sm font-semibold uppercase tracking-wider;
}

.app-header__upload-icon {
  @apply nav-item ml-auto flex items-center gap-2 rounded px-3  py-2;
}

.app-header__upload-icon:hover {
  @apply border border-brand-500 text-white;
}
</style>
